module.exports = __webpack_public_path__ + "static/media/104-ecuador.f50dba4d.svg";